import { BookingPaymentSource, usePrevious } from 'obt-common';

interface UseSelectCreatedPaymentSourceProps {
  paymentSources: BookingPaymentSource[];
  isCreatedPaymentSourceFetching: boolean;
  onPaymentSourceSelect: (selectedPaymentSources: BookingPaymentSource[]) => void;
  setIsCreatedPaymentSourceFetching: (isCreatingCard: boolean) => void;
  selectedPaymentSourceIds: string[];
}

const useSelectCreatedPaymentSource = ({
  paymentSources,
  isCreatedPaymentSourceFetching,
  onPaymentSourceSelect,
  setIsCreatedPaymentSourceFetching,
  selectedPaymentSourceIds,
}: UseSelectCreatedPaymentSourceProps) => {
  const oldPaymentSources = usePrevious(paymentSources);

  if (isCreatedPaymentSourceFetching) {
    const oldPaymentSourceIds = oldPaymentSources?.map((source) => source.id);
    const paymentSourceIds = paymentSources.map((source) => source.id);
    const newPaymentSourceId = paymentSourceIds.filter((x) => !oldPaymentSourceIds?.includes(x))[0];
    const newPaymentSource = paymentSources.find((source) => source.id === newPaymentSourceId);

    if (newPaymentSource) {
      const updatedPaymentSourcesIds = [...selectedPaymentSourceIds];
      updatedPaymentSourcesIds[0] = newPaymentSource.id;
      const updatedPaymentSources = updatedPaymentSourcesIds.map((id) =>
        paymentSources.find((source) => source.id === id),
      ) as BookingPaymentSource[];
      onPaymentSourceSelect([...updatedPaymentSources]);
      setIsCreatedPaymentSourceFetching(false);
    }
  }
};

export default useSelectCreatedPaymentSource;
